// @flow

import { get } from '../../utils/api';

/**
 * Leslie's property-level on/off status.
 *
 * Deliberately not the `/{organizationId}/properties/{propertyId}/leslie-configs` route: that
 * one serves the whole configuration row - webhook URL, vendor validation key - to the vendor
 * integration. This one answers only the question the screen asks, and a property that was
 * never onboarded to Leslie comes back as `{ enabled: false }` rather than an empty body.
 */
export function fetchPropertyLeslieStatus({
  selectedProperty,
}: {
  selectedProperty: Object,
}): Promise<{ enabled: boolean }> {
  // `fullError: true` gets the raw Boom body (`{ statusCode, error, message }`) instead of
  // the flattened message string, so the caller can tell a forbidden read - which this tab
  // reaches for roles without prospect-read - from a genuine failure.
  return get(
    `/${selectedProperty.organizationId}/${selectedProperty.id}/leslie-config`,
    { fullError: true },
  );
}

/**
 * Cora's property-level configuration. The card reads only `isEnabled`; a property with no
 * Cora row answers `{ isEnabled: false }`, never a 404.
 */
export function fetchPropertyCoraStatus({
  selectedProperty,
}: {
  selectedProperty: Object,
}): Promise<{ isEnabled: boolean }> {
  return get(
    `/api/v2/${selectedProperty.organizationId}/properties/${selectedProperty.id}/agents/cora/config`,
    { fullError: true },
  );
}
